import CreateRouteData from "../../domain/weather_routing/create_route/data";
import RoutePointData from "../../domain/weather_routing/route_point/data";
import HttpError from "../http_error";
import weatherRoutingAxiosInstance from "../weather_routing_axios_instance";

export default class WeatherRoutingRouteService {
  constructor(paDbUrl, companyId, customRouteFromJsonMapper, createRouteDataToJsonMapper) {
    this.paDbUrl = paDbUrl;
    this.companyId = companyId;
    this.customRouteFromJsonMapper = customRouteFromJsonMapper;
    this.createRouteDataToJsonMapper = createRouteDataToJsonMapper;
    this.weatherRoutingAxiosInstance = weatherRoutingAxiosInstance;
  }

  // TODO: isPortToPort should become an enum
  async postSimpleRoute(accessToken, theyrAccessToken, pointCoordinates, fromPort, toPort) {
    const isPortToPort = pointCoordinates === null;
    const params = isPortToPort
      ? this._generatePortToPortRoute(fromPort, toPort)
      : this._generatePointToPortRoute(pointCoordinates, toPort);

    const requestParams = {
      method: "POST",
      url: `${this.paDbUrl}/route`,
      headers: {
        accept: "application/json",
        "Content-type": "application/json",
        "access-token": `${accessToken}`,
        "theyr-token": `${theyrAccessToken}`,
        data: "{\"verified\":false}",
      },
      data: params
    };

    const response = await weatherRoutingAxiosInstance.request(requestParams);

    if (response.status >= 200 && response.status < 400) {
      return this.customRouteFromJsonMapper(response.data);
    }
    else {
      throw new HttpError(response.statusText, response.status);
    }

  }

  async post(accessToken, theyrAccessToken, createRouteData) {

    const requestBody = this.createRouteDataToJsonMapper(createRouteData);

    const requestParams = {
      method: "POST",
      url: `${this.paDbUrl}/route`,
      headers: {
        accept: "application/json",
        "Content-type": "application/json",
        "access-token": `${accessToken}`,
        "theyr-token": `${theyrAccessToken}`,
        data: "{\"verified\":false}",
      },
      data: requestBody
    };
    try {
      const response = await weatherRoutingAxiosInstance.request(requestParams);
      return this.customRouteFromJsonMapper(response.data);
    } catch (error) {
      throw new HttpError(error.response.statusText, error.response.status);
    }

  }

  async getMany(accessToken, theyrAccessToken, offset = 0) {

    try {
      const response = await this.weatherRoutingAxiosInstance.get(
        `${this.paDbUrl}/route`,
        {
          accept: "application/json",
          headers: {
            "access-token": `${accessToken}`,
            "theyr-token": `${theyrAccessToken}`,
          },
          params: {
            company_id: this.companyId,
            limit: 10,
            offset_step: offset
          }
        }
      );
      const result = response.data.map((datum) => this.customRouteFromJsonMapper(datum));
      return result;
    } catch (error) {
      throw new HttpError(error.response.statusText, error.response.status);
    }
  }

  async delete(accessToken, theyrAccessToken, id, theyrId) {
    try {
      await weatherRoutingAxiosInstance.delete(
        `${this.paDbUrl}/route/${id}`,
        {
          accept: "application/json",
          headers: {
            "access-token": `${accessToken}`,
            "theyr-token": `${theyrAccessToken}`,
          },
          params: {
            theyr_id: theyrId
          }
        }
      );

    } catch (error) {
      throw new HttpError(error.response.data.detail, error.response.status);
    }
  }

  _generatePointToPortRoute(pointCoordinates, port) {
    const point = new RoutePointData(
      0,
      pointCoordinates.Latitude,
      pointCoordinates.Longitude,
      null
    );

    const portCoordinates = port.locode != ""
      ? new RoutePointData(
        1,
        null,
        null,
        port.locode
      )
      : new RoutePointData(
        1,
        port.lat,
        port.lon,
        null
      );

    const routePoints = [
      point,
      portCoordinates
    ];

    const createRouteData = new CreateRouteData(
      this.companyId,
      routePoints,
      `From [${port.lon.toFixed(2)},${port.lat.toFixed(2)} to ${port.name}]`
    );

    return this.createRouteDataToJsonMapper(createRouteData);

  }

  _generatePortToPortRoute(fromPort, toPort) {
    const fromPortRoutePoint = fromPort.locode != "" ?
      new RoutePointData(
        0,
        null,
        null,
        fromPort.locode
      )
      : new RoutePointData(
        0,
        fromPort.lat,
        fromPort.lon,
        null
      );

    const toPortRoutePoint = toPort.locode != ""
      ? new RoutePointData(
        1,
        null,
        null,
        toPort.locode
      )
      : new RoutePointData(
        1,
        toPort.lat,
        toPort.lon,
        null
      );

    const routePoints = [
      fromPortRoutePoint,
      toPortRoutePoint
    ];

    const createRouteData = new CreateRouteData(
      this.companyId,
      routePoints,
      `From ${fromPort.name} to ${toPort.name}`
    );

    return this.createRouteDataToJsonMapper(createRouteData);
  }

}
